import type { ProjectDocument } from "@needle-tools/addressing/document";
import { createDecorator } from "../../../../platform/instantiation/common/registry.js";

export interface OriginalSceneExportOptions { sceneRef?: string; download?: boolean; allowPartial?: boolean }
export interface OriginalSceneLoadOptions { sceneRef?: string; document?: unknown; name?: string }
export const IOriginalSceneDocumentService = createDecorator<IOriginalSceneDocumentService>("originalSceneDocumentService");
export interface IOriginalSceneDocumentService {
    export(options: OriginalSceneExportOptions): Promise<{ document?: ProjectDocument; issues: string[] } | undefined>;
    load(options?: OriginalSceneLoadOptions): Promise<{ issues: string[]; applied: number; cancelled?: boolean } | undefined>;
}
